import ICONS from "../../../../../assets/Icons";
import CommonToast from "../../../../_utils/CommonToast";
import { formatAccountNumber } from "../../../../_utils/FormatAccountNumber";
import DataActionField from "../../../../_utils/TransactionCommonComponents/DataActionField";

const BeneficiaryRecreateTxnStepSourceDestination = ({
  txnPayload,
  setSourceSelect,
  isConfidential,
  setIsConfidential,
  setMapingData,
  accountSelect,
  setAccountSelect,
  setIsAutoFilledSource,
  isAutoFilledSource,
  txnData,
}) => {
  const sourceAccNo = txnData?.owner_account_bank_acc_no;

  const destinationAccNo = txnData?.beneficiary_account_bank_acc_no;

  const config = txnData?.confidential_transaction !== "N";

  return (
    <>
      <div className="mt-[var(--banklogo-width-lg)] Qsmd:mt-margin-md w-full mb-margin-md">
        <div className="flex flex-col Qsmd:flex-row Qlg:gap-gap-xl gap-gap-md Qlg:pt-padding-base pt-padding-md px-padding-md Qsmd:px-padding-base">
          <DataActionField
            label="Source Account"
            value={formatAccountNumber(sourceAccNo)}
            isActive={isAutoFilledSource}
            icon={
              txnPayload?.ownerBankAccountNo === sourceAccNo
                ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                : ICONS?.AUTOFILL_WHITE
            }
            onClick={() => {
              setIsAutoFilledSource(true);
              setSourceSelect(true);
              setMapingData("renderSource");
            }}
            hoverEnabled={txnPayload?.ownerBankAccountNo !== sourceAccNo}
          />
          <DataActionField
            label="Destination Account"
            value={formatAccountNumber(destinationAccNo)}
            isActive={accountSelect}
            disabled={!txnPayload?.ownerBankAccountNo}
            icon={
              txnPayload?.beneAccountId === txnData?.beneficiary_account_id
                ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                : ICONS?.AUTOFILL_WHITE
            }
            onClick={() => {
              if (!txnPayload?.ownerBankAccountNo) return;
              const approvalStatus =
                txnData?.beneficiary_account_approval_status;
              if (
                approvalStatus !== "approved" &&
                approvalStatus !== "pending"
              ) {
                CommonToast({
                  text: "Unable to find destination account.",
                  icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                  variant: "var(--error)",
                  buttonNeeded: false,
                });
                return;
              }
              setAccountSelect(true);
              setMapingData("renderData");
            }}
            hoverEnabled={accountSelect === false}
          />
        </div>

        <div className="flex flex-col Qsmd:flex-row Qlg:gap-gap-xl gap-gap-md pt-padding-md px-padding-md Qsmd:px-padding-base">
          <DataActionField
            label="Create As Confidential Transaction"
            value={
              txnData?.confidential_transaction === "Y"
                ? "Confidential transaction enabled"
                : "Confidential transaction disabled"
            }
            isActive={isConfidential === config}
            icon={
              isConfidential === config
                ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                : ICONS?.AUTOFILL_WHITE
            }
            onClick={() => {
              setIsConfidential(txnData?.confidential_transaction === "Y");
            }}
            hoverEnabled={isConfidential !== config}
          />
          <div className="invisible w-full">
            <DataActionField label="" />
          </div>
        </div>
      </div>
    </>
  );
};

export default BeneficiaryRecreateTxnStepSourceDestination;
